// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The Arena - Sports Prediction Platform */

/* Hero section */
.hero-bg {
    position: relative;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.hero-bg::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, rgba(2, 6, 23, 0.85), rgba(2, 6, 23, 0.95));
}

/* Sport category cards */
.sport-card {
    position: relative;
    overflow: hidden;
    border-radius: 0.375rem;
}

.sport-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(2, 6, 23, 0.9), transparent);
    z-index: 1;
}

.sport-card img {
    transition: transform 0.5s ease;
}

.sport-card:hover img {
    transform: scale(1.1);
}

/* Stats counter */
.stat-counter {
    font-variant-numeric: tabular-nums;
}

/* Progress bar animation */
.progress-animate {
    transition: width 1s ease-out;
}

/* Question card states */
.question-option {
    transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.1s ease;
}

.question-option:hover {
    transform: scale(1.02);
}

.question-option.selected {
    border-color: hsl(var(--primary));
    background-color: hsl(var(--primary) / 0.1);
}

.question-option.correct {
    border-color: hsl(var(--success));
    background-color: hsl(var(--success) / 0.1);
}

.question-option.incorrect {
    border-color: hsl(var(--destructive));
    background-color: hsl(var(--destructive) / 0.1);
}

/* Ranking position styles */
.rank-gold {
    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.rank-silver {
    background: linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.rank-bronze {
    background: linear-gradient(135deg, #CD7F32 0%, #A0522D 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

/* Event status badges */
.status-active {
    border-color: rgb(16 185 129 / 0.2);
    background-color: rgb(16 185 129 / 0.1);
    --tw-text-opacity: 1;
    color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}

.status-closed {
    border-color: rgb(245 158 11 / 0.2);
    background-color: rgb(245 158 11 / 0.1);
    --tw-text-opacity: 1;
    color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}

.status-completed {
    border-color: rgb(100 116 139 / 0.2);
    background-color: rgb(100 116 139 / 0.1);
    --tw-text-opacity: 1;
    color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

/* Admin sidebar */
.admin-nav-item {
    transition: background-color 0.2s ease, color 0.2s ease;
}

.admin-nav-item:hover {
    background-color: hsl(var(--accent));
}

.admin-nav-item.active {
    background-color: hsl(var(--primary) / 0.1);
    color: hsl(var(--primary));
    border-left: 3px solid hsl(var(--primary));
}

/* Mobile menu */
@media (max-width: 768px) {
    .mobile-menu-open {
        overflow: hidden;
    }
}

/* Theme transition */
html {
    transition: background-color 0.3s ease, color 0.3s ease;
}

/* Focus states */
button:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
    outline: 2px solid hsl(var(--ring));
    outline-offset: 2px;
}

/* Loading skeleton pulse */
@keyframes skeleton-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
}

.skeleton-pulse {
    animation: skeleton-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C,iBAAiB;AACjB;IACI,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,kFAAkF;AACtF;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,qEAAqE;IACrE,UAAU;AACd;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,kCAAkC;AACtC;;AAEA,2BAA2B;AAC3B;IACI,6BAA6B;AACjC;;AAEA,yBAAyB;AACzB;IACI,mFAAmF;AACvF;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,2CAA2C;AAC/C;;AAEA;IACI,iCAAiC;IACjC,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,+CAA+C;AACnD;;AAEA,4BAA4B;AAC5B;IACI,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA,wBAAwB;AAEpB;IAAA,mCAA+D;IAA/D,uCAA+D;IAA/D,oBAA+D;IAA/D;AAA+D;;AAI/D;IAAA,mCAAyD;IAAzD,uCAAyD;IAAzD,oBAAyD;IAAzD;AAAyD;;AAIzD;IAAA,oCAAyD;IAAzD,wCAAyD;IAAzD,oBAAyD;IAAzD;AAAyD;;AAG7D,kBAAkB;AAClB;IACI,uDAAuD;AAC3D;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,2CAA2C;IAC3C,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA,gBAAgB;AAChB;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA,qBAAqB;AACrB;IACI,uDAAuD;AAC3D;;AAEA,iBAAiB;AACjB;;;;IAII,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,WAAW,UAAU,EAAE;IACvB,MAAM,YAAY,EAAE;AACxB;;AAEA;IACI,kEAAkE;AACtE","sourcesContent":["/* The Arena - Sports Prediction Platform */\n\n/* Hero section */\n.hero-bg {\n    position: relative;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.hero-bg::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(to bottom, rgba(2, 6, 23, 0.85), rgba(2, 6, 23, 0.95));\n}\n\n/* Sport category cards */\n.sport-card {\n    position: relative;\n    overflow: hidden;\n    border-radius: 0.375rem;\n}\n\n.sport-card::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(to top, rgba(2, 6, 23, 0.9), transparent);\n    z-index: 1;\n}\n\n.sport-card img {\n    transition: transform 0.5s ease;\n}\n\n.sport-card:hover img {\n    transform: scale(1.1);\n}\n\n/* Stats counter */\n.stat-counter {\n    font-variant-numeric: tabular-nums;\n}\n\n/* Progress bar animation */\n.progress-animate {\n    transition: width 1s ease-out;\n}\n\n/* Question card states */\n.question-option {\n    transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.1s ease;\n}\n\n.question-option:hover {\n    transform: scale(1.02);\n}\n\n.question-option.selected {\n    border-color: hsl(var(--primary));\n    background-color: hsl(var(--primary) / 0.1);\n}\n\n.question-option.correct {\n    border-color: hsl(var(--success));\n    background-color: hsl(var(--success) / 0.1);\n}\n\n.question-option.incorrect {\n    border-color: hsl(var(--destructive));\n    background-color: hsl(var(--destructive) / 0.1);\n}\n\n/* Ranking position styles */\n.rank-gold {\n    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.rank-silver {\n    background: linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.rank-bronze {\n    background: linear-gradient(135deg, #CD7F32 0%, #A0522D 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n/* Event status badges */\n.status-active {\n    @apply bg-emerald-500/10 text-emerald-500 border-emerald-500/20;\n}\n\n.status-closed {\n    @apply bg-amber-500/10 text-amber-500 border-amber-500/20;\n}\n\n.status-completed {\n    @apply bg-slate-500/10 text-slate-400 border-slate-500/20;\n}\n\n/* Admin sidebar */\n.admin-nav-item {\n    transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.admin-nav-item:hover {\n    background-color: hsl(var(--accent));\n}\n\n.admin-nav-item.active {\n    background-color: hsl(var(--primary) / 0.1);\n    color: hsl(var(--primary));\n    border-left: 3px solid hsl(var(--primary));\n}\n\n/* Mobile menu */\n@media (max-width: 768px) {\n    .mobile-menu-open {\n        overflow: hidden;\n    }\n}\n\n/* Theme transition */\nhtml {\n    transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Focus states */\nbutton:focus-visible,\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible {\n    outline: 2px solid hsl(var(--ring));\n    outline-offset: 2px;\n}\n\n/* Loading skeleton pulse */\n@keyframes skeleton-pulse {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.5; }\n}\n\n.skeleton-pulse {\n    animation: skeleton-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
